/** Default logo / favicon for meeduang.com when tenant admin has not uploaded branding. */

export const MEEDUANG_BRAND_PATHS = {
  logo: '/branding/meeduang/logo-wordmark.svg',
  logoPng: '/branding/meeduang/logo-wordmark.png',
  logoIcon: '/branding/meeduang/logo-icon.svg',
  logoIconPng: '/branding/meeduang/logo-icon.png',
  favicon: '/branding/meeduang/favicon.svg',
  faviconPng: '/branding/meeduang/favicon.png',
} as const

export function isMeeduangWordmarkLogo(logoUrl?: string | null): boolean {
  const url = String(logoUrl || '').toLowerCase()
  if (!url) return false
  if (url.includes('/branding/meeduang/logo-wordmark')) return true
  // Tenant admin S3 upload: tenants/meeduang/branding/logo.*
  if (url.includes('/tenants/meeduang/branding/logo')) return true
  return false
}

/** Tagline after " - " in siteTitle (e.g. "ดวงของคุณเพิ่งเริ่มขึ้น"). */
export function resolveBrandTagline(siteName?: string | null): string {
  const raw = String(siteName || '').trim()
  if (!raw) return ''
  const splitters = [' - ', ' – ', ' | ']
  for (const splitter of splitters) {
    const idx = raw.indexOf(splitter)
    if (idx >= 0) {
      const tail = raw.slice(idx + splitter.length).trim()
      if (tail) return tail
    }
  }
  return ''
}

export function isMeeduangHost(hostname?: string): boolean {
  const host = String(hostname || (typeof window !== 'undefined' ? window.location.hostname : ''))
    .trim()
    .toLowerCase()
  if (!host) return false
  return host === 'meeduang.com' || host === 'www.meeduang.com' || host.endsWith('.meeduang.com')
}

export function resolveMeeduangLogoUrl(customLogo?: string | null): string {
  const url = String(customLogo || '').trim()
  if (url) return url
  if (isMeeduangHost()) return MEEDUANG_BRAND_PATHS.logo
  return ''
}

export function resolveMeeduangFaviconUrl(customFavicon?: string | null, fallbackUrl?: string): string {
  const url = String(customFavicon || '').trim()
  if (url) return url
  if (isMeeduangHost()) return MEEDUANG_BRAND_PATHS.favicon
  return String(fallbackUrl || '').trim()
}
